module.exports = __webpack_public_path__ + "static/value-ac86ee875129bb2a1c3bc4b148acb802.png";